import './template-link.scss';

import TemplateLink from './TemplateLink';

export default TemplateLink;
